import React from 'react';
import './AddPaymentPorterWizard.css';

const WizardStepper = ({ steps, currentStep }) => (
    <div className="ppw-stepper">
        {steps.map((s, i) => {
            const state = currentStep > s.num ? 'done' : currentStep === s.num ? 'active' : 'inactive';
            return (
                <React.Fragment key={s.num}>
                    <div className="ppw-step-item">
                        <div className={`ppw-step-circle ${state}`}>
                            {state === 'done' ? (
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            ) : s.num}
                        </div>
                        <span className={`ppw-step-label ${state}`}>{s.label}</span>
                    </div>
                    {i < steps.length - 1 && (
                        <div className={`ppw-step-connector ${currentStep > s.num ? 'done' : ''}`} />
                    )}
                </React.Fragment>
            );
        })}
    </div>
);

export default WizardStepper;
